<template>
  <div class="home">
    <CalendarMonth
      :load-calendar-events="loadCalendarEvents"
    />
  </div>
</template>

<script>
import CalendarMonth from './module/calendar/CalendarMonth'
import moment from 'moment'

export default {
  name: 'home',

  data () {
    return {
      loading: false
    }
  },

  components: {
    CalendarMonth
  },

  computed: {

  },

  methods: {
    loadCalendarEvents (start, end) {
      const lang = this.$store.getters.language
      let filters = [
        {
          key: 'dateEnd_from',
          // subtract days because month view shows few days more
          value: moment(start.date).subtract(6, 'days').format('YYYY-MM-DD')
        },
        {
          key: 'dateStart_to',
          // add days because month view shows few days more
          value: moment(end.date).add(6, 'days').format('YYYY-MM-DD')
        },
      ]
      return new Promise(resolve => {
        this.$store.dispatch('getListReferenceItems', {
          moduleName: 'bookings',
          pagination: {
            rowsPerPage: 200,
            page: 1
          },
          filters: filters
        }).then((result) => {
          let events = []
          if (!result || !result.items) {
            resolve([])
            return
          }
          // Filter out cancelled bookings
          result.items.filter(item => {
            return item.status?.id !== '5bebc64f46853c27bcfe3dc9'
          }).forEach(item => {
            if (!item.object) {
              return
            }
            const info = '<b>' + item.object.objectName + '</b><br><br>' +
                (item.customerName && item.customerName !== null ? item.customerName : '') + '<br>'
              + (item.customerPhone && item.customerPhone !== null ? item.customerPhone: '') + '<br>' +
              (item.customerEmail && item.customerEmail !== null ? item.customerEmail + '' : '') +
                '<br>' + (item.notes && item.notes !== null ? item.notes : '')
            let name = item.customerName || item.notes
            name = name || (item.status && item.status['name_' + lang])
            events.push({
              name: item.object.csrId + ': ' + name,
              start: moment(item.dateStart).format('YYYY-MM-DD') + ' 16:00',
              end: moment(item.dateStart).format('YYYY-MM-DD') + ' 17:00',
              color: 'red',
              info,
              link: '/bookings/form/' + item._id,
              item: item,
            })
            events.push({
              name: item.object.csrId + ': ' + name,
              start: moment(item.dateEnd).format('YYYY-MM-DD') + ' 12:00',
              end: moment(item.dateEnd).format('YYYY-MM-DD') + ' 13:00',
              color: 'green',
              info,
              link: '/bookings/form/' + item._id,
              item: item,
            })
          })
          resolve(events)
        })
      })
    }
  }
}
</script>

<style>
.home {
  width: 100%;
}
</style>
